import { connect } from 'react-redux';
import { getEditorDraft } from '../../../DaEditorWrapper/redux/selectors';
import { isInitialized, getCommentState } from '../../redux/selectors';
import { generateReplyEditorId } from '../../utils';
var getPropWithSelector = function (state, commentId, selector, defaultValue) {
    if (isInitialized(commentId)(state)) {
        return selector(commentId)(state);
    }
    return defaultValue;
};
var mapStateToProps = function (state, ownProps) { return ({
    comment: getPropWithSelector(state, ownProps.comment.commentId, getCommentState, ownProps.comment),
    hasReplyDraft: !!getEditorDraft(state, generateReplyEditorId(ownProps.comment)),
}); };
export default connect(mapStateToProps);
//# sourceMappingURL=CommentContextProvider.container.js.map